import request from './request'
import appConfig from '@/config/app'
import api from '../api'
import searchable from '../services/searchable'

const { search } = searchable

/**
 * ===================
 * Billing Status API
 * ===================
 */
export default {
  baseUrl: `${process.env.VUE_APP_FINANCE_API}/api`,
  url: 'billing-status',
  ...api,
  search,

  namespaced: true,
  strict: appConfig.store.strict,
  state: {
    baseURL: appConfig.services.finance.baseURl,
    url: '/api/billing-status',
    billingStatusList: [],
    ...api,
    search
  },
  mutations: {
    setList (state, payload) {
      state.billingStatusList = payload
    }
  },
  actions: {
    /**
     * Action to update field value
     *
     * @param {state, commit} commit
     * @param {payload} payload
     * @return void
     */
    async populateBillingStatusList ({ state, commit }) {
      const payload = {
        baseURL: state.baseURL,
        url: state.url
      }

      await request.get({}, payload)
        .then(({ data }) => {
          commit('setList', data)
        })
        .catch(({ response }) => {
          throw response
        })
    },
    /**
     * empty listing
     *
     * @param {commit} commit
     * @return void
     */
    async clearBillingStatusList ({ commit }) {
      commit('setList', [])
    }
  }
}
